import { FC } from 'react';

import 'components/Spinner/Spinner.less';

const Spinner: FC = () => <div className="loader" />;

export default Spinner;
